import { EquipmentService } from "@/common/api.service"
import { FETCH_EQUIPMENTS, FETCH_INDIVIDUAL_EQUIPMENT, ADD_EQUIPMENT, UPDATE_EQUIPMENT,RESET_STATE, DELETE_EQUIPMENT } from "./actions.type"
import { SET_EQUIPMENTS, SET_INDIVIDUAL_EQUIPMENT, SET_ERROR_EQUIPMENT,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        equipments: [],
        individualequipment: [],
        equipmenterrors: null,
    }
}

let state = initialState()

const getters = {
    equipments(state) {
        return state.equipments
    },
    individualequipment(state) {
        return state.individualequipment
    }
}

const actions = {
    async [FETCH_EQUIPMENTS](context, slug) {
        const { data } = await EquipmentService.get(slug)
        context.commit(SET_EQUIPMENTS, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_EQUIPMENT](context, slug) {
        const { data } = await EquipmentService.get(slug)
        context.commit(SET_INDIVIDUAL_EQUIPMENT, data.data)
        return data;
    },
    async [ADD_EQUIPMENT](context, payload) {
        return await EquipmentService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT, error.response.data.errors)
        });
    },
    async [UPDATE_EQUIPMENT](context, payload) {
        return await EquipmentService.create(payload, (payload.get('equipment_id')?payload.get('equipment_id'):'' ))
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT, error.response.data.errors)
        });
    },
    async [DELETE_EQUIPMENT] (context, equipment_id) {
        return await EquipmentService.delete(equipment_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_EQUIPMENT, error.response.data.errors)
        });
    },
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_EQUIPMENT](state, error) {
        state.equipmenterrors = error
    },
    [SET_EQUIPMENTS](state, equipmentdata) {
        state.equipments = equipmentdata
    },
    [SET_INDIVIDUAL_EQUIPMENT](state, individualequipmentdata) {
        state.individualequipment = individualequipmentdata
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
